import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';

import { useCategoriaEvento, useLogin, usePartecipante } from '../reducers';
import { displayBadgePermesso, displayUser } from '../utils';
import { login_url } from '../globals';

const PartecipantiCategoriaEvento = (props: {}) => {
  const { pk } = useParams<{ pk: string }>();
  const categorieEvento = useCategoriaEvento(props);
  const partecipanti = usePartecipante(props);
  const login = useLogin();
  const categoryId = pk && /^[1-9]\d*$/.test(pk) ? Number(pk) : NaN;
  const categoria = Number.isSafeInteger(categoryId) ? categorieEvento.find(item => item.id === categoryId) : undefined;

  useEffect(() => {
    if (!login.logged_in) login_url();
  }, [login.logged_in]);

  useEffect(() => {
    document.title = categoria ? `Partecipanti - ${categoria.nome} - Owlitrack` : 'Partecipanti categoria evento - Owlitrack';
  }, [categoria]);

  if (!login.logged_in) return null;

  if (!categoria) {
    return <div className="container mb-4">
      <h1>Categoria evento non trovata</h1>
      <p>Nessuna categoria evento con indice {pk} trovata.</p>
    </div>;
  }

  const visibili = partecipanti.filter(partecipante => partecipante.permessi === 'a' || (
    ['e', 's', 'm'].includes(partecipante.permessi) && partecipante.eventi_assegnati.includes(categoryId)
  )).sort((first, second) =>
    first.user.last_name.localeCompare(second.user.last_name, 'it') ||
    first.user.first_name.localeCompare(second.user.first_name, 'it') ||
    first.user.username.localeCompare(second.user.username, 'it') || first.id - second.id
  );

  return <div className="container mb-4">
    <h1>Partecipanti con accesso a {categoria.nome}</h1>
    <p className="text-muted">
      Amministratori e partecipanti con permesso Evento, Smistatore o Moderatore assegnati alla categoria {categoria.nome}.
    </p>
    <p>{visibili.length} {visibili.length === 1 ? 'partecipante' : 'partecipanti'}</p>
    {visibili.length ? <div className="table-responsive">
      <table className="table table-hover">
        <thead className="thead-light"><tr>
          <th scope="col">Nome</th>
          <th scope="col">Permesso</th>
          <th scope="col">Accesso</th>
        </tr></thead>
        <tbody>{visibili.map(partecipante => <tr key={partecipante.id}>
          <td><Link to={`/utente/${partecipante.id}/`}>{displayUser(partecipante.user) || partecipante.user.username}</Link></td>
          <td>{displayBadgePermesso(partecipante.permessi)}</td>
          <td>{partecipante.permessi === 'a' ? 'Amministratore: tutti gli eventi' : 'Categoria evento assegnata'}</td>
        </tr>)}</tbody>
      </table>
    </div> : <p>Nessun partecipante ha accesso a questa categoria evento.</p>}
    <Link to="/utente/">Tutti i partecipanti</Link>
  </div>;
};

export default PartecipantiCategoriaEvento;
